import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const grpoComponent: ComponentDef = {
  id: 'grpo',
  name: 'GRPO',
  description: 'Group Relative Policy Optimization trains the policy against a group baseline without a separate critic.',
  category: 'training',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 },
    { name: 'group_size', label: 'Group size', type: 'number', default: 8, min: 2, max: 64, step: 1 }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const seq_len = Number(params.seq_len);
    const group_size = Number(params.group_size);

    const g = new GraphBuilder();
    g.input('prompt', [seq_len, d_model]);

    g.replicate('group', 'prompt', [seq_len, d_model], group_size);
    g.linear('policy', 'group', [d_model, d_model]);
    g.linear('old_policy', 'group', [d_model, d_model]);
    g.metric('reward', 'policy', 'Group Reward');
    g.scale('baseline', 'reward', `baseline (${group_size})`);
    g.add('advantage', 'policy', 'baseline');
    g.scale('kl', 'old_policy', 'KL');
    g.add('loss', 'advantage', 'kl');
    g.output('out', 'loss');
    return g.build();
  }
};
